<ion-button class="custom-thumb" *ngIf="!video.thumb" (click)="select()">
  <ion-icon name="videocam"></ion-icon>
  <!--ion-icon name="play-circle-sharp"></ion-icon-->
</ion-button>
<ion-button class="video-thumb custom-thumb" [ngStyle]="{'background-image': 'url(' + thumbpath + ')'}" *ngIf="video.thumb" (click)="select()">
  <div></div>
  <!--ion-icon name="play-circle-sharp"></ion-icon-->
</ion-button>